var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95242 1.9048C8.95242 1.58921 9.20826 1.33337 9.52385 1.33337H14.0953C14.4109 1.33337 14.6667 1.58921 14.6667 1.9048V6.47623C14.6667 6.79182 14.4109 7.04766 14.0953 7.04766C13.7797 7.04766 13.5238 6.79182 13.5238 6.47623V3.28435L6.88029 9.92791C6.65713 10.1511 6.29533 10.1511 6.07217 9.92791C5.84901 9.70475 5.84901 9.34295 6.07217 9.11979L12.7157 2.47623H9.52385C9.20826 2.47623 8.95242 2.22039 8.95242 1.9048ZM3.42861 4.00004C2.90263 4.00004 2.47623 4.42644 2.47623 4.95242V12.5715C2.47623 13.0975 2.90263 13.5238 3.42861 13.5238H11.0477C11.5736 13.5238 12 13.0975 12 12.5715V9.52385C12 9.20826 12.2559 8.95242 12.5715 8.95242C12.8871 8.95242 13.1429 9.20826 13.1429 9.52385V12.5715C13.1429 13.7286 12.2048 14.6667 11.0477 14.6667H3.42861C2.27144 14.6667 1.33337 13.7286 1.33337 12.5715V4.95242C1.33337 3.79525 2.27144 2.85718 3.42861 2.85718H6.47623C6.79182 2.85718 7.04766 3.11302 7.04766 3.42861C7.04766 3.7442 6.79182 4.00004 6.47623 4.00004Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.73d8b900f2bf425c78f42f84d9c4249c.svg";
export { ForwardRef as ReactComponent };